import { action } from 'satcheljs';
import RibbonPlugin from '../plugin/RibbonPlugin';
import RibbonViewState from '../store/schema/RibbonViewState';

export default action(
    'updateRibbonState',
    (
        plugin: RibbonPlugin,
        viewState: RibbonViewState,
        updateContextualFormatBar: boolean,
        delay: boolean
    ) => ({
        plugin,
        viewState,
        updateContextualFormatBar,
        delay,
    })
);
